import { render } from "./GrModalLarge.vue?vue&type=template&id=2dab04dc&scoped=true"
import script from "./GrModalLarge.vue?vue&type=script&lang=js"
export * from "./GrModalLarge.vue?vue&type=script&lang=js"

import "./GrModalLarge.vue?vue&type=style&index=0&id=2dab04dc&scoped=true&lang=css"

import exportComponent from "/var/www/greenified-mono-staging/ims.greenified.se/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2dab04dc"]])

export default __exports__